import { FC, useState } from 'react';
// import useTranslation from '../../../hooks/useTranslation';
import SidebarLayout from '../../common/SidebarLayout';
import { ProjectListSidebarProps } from './ProjectListSidebarProps';
import CountrySelect from '../CountrySelect';
import { Stack } from '@mui/material';
import Button from '@ingka/button';
import useTranslation from '../../hooks/useTranslation';

export const ProjectListSidebar: FC<ProjectListSidebarProps> = ({
  countryList,
  selectedCountryCodes,
  onCountryCodeChange,
  handleOpenCreateProjectModal,
  bulkCreateHandler,
}) => {
  const t = useTranslation();

  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <SidebarLayout
      mainItem={() => (
        <Stack direction={'column'} spacing={2}>
          <CountrySelect
            countryList={countryList}
            selectedCountryCodes={selectedCountryCodes}
            onCountryCodeChange={onCountryCodeChange}
            hidden={!drawerOpen}
          />
          {drawerOpen && (
            <>
              <Button
                onClick={handleOpenCreateProjectModal}
                type={'primary'}
                data-testid={'create-new-project'}
              >
                {t('projects.createProject')}
              </Button>
              <Button
                onClick={bulkCreateHandler}
                type={'secondary'}
                data-testid={'bulk-create-button'}
              >
                Bulk create projects
              </Button>
            </>
          )}
        </Stack>
      )}
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
    />
  );
};
